"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BiofertilizerFacility = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const Resources_1 = require("../../Resources");
const ResourceType_1 = require("../../ResourceType");
const SpaceBonus_1 = require("../../SpaceBonus");
const SpaceType_1 = require("../../SpaceType");
const TileType_1 = require("../../TileType");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const AddResourcesToCard_1 = require("../../deferredActions/AddResourcesToCard");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const Units_1 = require("../../Units");
class BiofertilizerFacility extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.BIOFERTILIZER_FACILITY,
            tags: [Tags_1.Tags.MICROBE, Tags_1.Tags.BUILDING],
            cost: 12,
            productionBox: Units_1.Units.of({ plants: 1 }),
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.tag(Tags_1.Tags.SCIENCE)),
            metadata: {
                description: 'Requires 1 science tag. Increase your plant production 1 step. ' +
                    'Add 2 microbes to ANY card. ' +
                    'Place this tile which grants an ADJACENCY BONUS of 1 plant and 1 microbe.',
                cardNumber: 'A02',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.plants(1));
                    b.microbes(2);
                    b.br;
                    b.tile(TileType_1.TileType.BIOFERTILIZER_FACILITY, false, true);
                }),
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.PLANTS, 1);
        player.game.defer(new AddResourcesToCard_1.AddResourcesToCard(player, ResourceType_1.ResourceType.MICROBE, { count: 2 }));
        return new SelectSpace_1.SelectSpace('Select space for Biofertilizer Facility tile', player.game.board.getAvailableSpacesOnLand(player), TileType_1.TileType.BIOFERTILIZER_FACILITY, (space) => {
            player.game.addTile(player, SpaceType_1.SpaceType.LAND, space, {
                tileType: TileType_1.TileType.BIOFERTILIZER_FACILITY,
                card: this.name,
            });
            space.adjacency = {
                bonus: [SpaceBonus_1.SpaceBonus.PLANT, SpaceBonus_1.SpaceBonus.MICROBE],
            };
            return undefined;
        });
    }
}
exports.BiofertilizerFacility = BiofertilizerFacility;
//# sourceMappingURL=BiofertilizerFacility.js.map